import { HorizontalSpacer } from "@/components/layout/horizontal-spacer";
import { VerticalContainer } from "@/components/layout/vertical-container";
import { EnvelopeIcon, PhoneIcon } from "../icons/icons";
import { HorizontalContainer } from "../layout/horizontal-container";
import { VerticalSpacer } from "../layout/vertical-spacer";
import { CopyToClipboardButton } from "./copy-to-clipboard-button";
import { LinkButton } from "./link-button";
import { Text } from "./text";

interface ContactUsEmailAndPhoneProps {
  emailAddress?: string;
  phoneNumber?: string;
  description?: string;
  showButton?: boolean;
}

export function ContactUsEmailAndPhone({
  emailAddress,
  phoneNumber,
  description,
  showButton,
}: ContactUsEmailAndPhoneProps) {
  return (
    <>
      <VerticalContainer horizontalPlacement={"center"} verticalPlacement={"space"} height={"full"}>
        <HorizontalContainer horizontalPlacement="center" width="full">
          {phoneNumber && (
            <HorizontalContainer noWrap={true} verticalPlacement="top">
              <VerticalSpacer />
              <>
                <LinkButton href={`tel:${phoneNumber}`}>
                  <HorizontalContainer horizontalPlacement="center" noWrap={true} verticalPlacement="center">
                    <PhoneIcon />
                    <VerticalSpacer />
                    <Text value={`${phoneNumber}`} size="normal" weight="bold" />
                  </HorizontalContainer>
                </LinkButton>

                <VerticalSpacer />
              </>
            </HorizontalContainer>
          )}

          <HorizontalContainer noWrap={true} verticalPlacement="top">
            {phoneNumber && <VerticalSpacer />}
            <CopyToClipboardButton
              icon={<EnvelopeIcon stripIcon={true} />}
              textToCopy={`${emailAddress ?? "3t@3t.no"}`}
            />
            {phoneNumber && <VerticalSpacer />}
          </HorizontalContainer>
        </HorizontalContainer>

        {description && <Text value={"Spørsmål?"} size="normal" weight="bold" align={"center"} />}
        {description && <Text value={description} size="normal" weight="bold" align={"center"} />}
        {showButton && (
          <>
            <HorizontalSpacer size="medium" />
            <LinkButton width="full" buttonType="secondary" href={`mailto:${emailAddress ?? "3t@3t.no"}`}>
              <Text size="large" weight="black" value="Send oss en e-post" />
            </LinkButton>
          </>
        )}
      </VerticalContainer>
    </>
  );
}
